import React, { useState, useRef, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import RequestServies from "../../../services/RequestServices";
import ItemsModal from "./ItemsModal";
import Swal from "sweetalert2";
import LocationServices from "../../../services/LocationServices";

const SuperBossPendingApproval = () => {
    const user = JSON.parse(localStorage.getItem("userDetails"));

    const [stores, setStores] = useState([]);
    const [selectedStore, setSelectedStore] = useState("");
    const [editModeId, setEditModeId] = useState(null);
    const [editModeValue, setEditModeValue] = useState("");
    const [open, setOpen] = useState(true);
    const [open2, setOpen2] = useState(true);
    const [gridInsideModal2, setGridInsideModal2] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [sort] = useState(40);
    const activePag = useRef(0);
    const [data, setData] = useState([]);
    const [selectedItem2, setSelectedItem2] = useState({});
    const [loading, setLoading] = useState(false);
    const [editItemId, setEditItemId] = useState(null);
    const [editQty, setEditQty] = useState("");
    const [test, setTest] = useState(0);
    const [requisition, setRequisiton] = useState();
    const [selectedRequisition, setSelectedRequisiton] = useState();
    const [run, setRun] = useState(0);

  useEffect(() => {
    setLoading(true);

    RequestServies.getStoresFromRequests()
        .then((res) => {
            const allStores = res?.data?.stores || [];

            // ✅ FILTER
            const filteredStores = allStores.filter(
                (s) => s.status === "pendingWithBoss"
            );

            // ✅ REMOVE DUPLICATES
            const uniqueStores = Array.from(
                new Map(
                    filteredStores.map(s => [s.storeId, s])
                ).values()
            );

            setStores(uniqueStores);

            if (uniqueStores.length > 0) {
                setSelectedStore(uniqueStores[0].storeId);
            } else {
                setSelectedStore("");
            }

            setLoading(false);
        })
        .catch((error) => {
            setLoading(false);
            console.error(error);
        });

}, []);
    // ================================
    // FETCH REQUISITIONS
    // ================================
    useEffect(() => {
        if (selectedStore) {
            setLoading(true);
            const status = "pendingWithBoss"; // 👈 after superAdmin approval

            RequestServies.getRequest(selectedStore, status)
                .then((res) => {
                    const list = res?.data?.data || [];

                    setRequisiton(list);

                    if (list.length > 0) {
                        setSelectedRequisiton(prev =>
                            prev && list.find(r => r._id === prev)
                                ? prev
                                : list[0]._id
                        );
                    } else {
                        // 🔥 MOST IMPORTANT FIX
                        setSelectedRequisiton(null);
                        setData([]); // clear table immediately
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    console.log(error);
                });
        }
    }, [selectedStore, run]);

    // ================================
    // FETCH ITEMS (IMPORTANT CHANGE)
    // ================================
    useEffect(() => {
        let isActive = true; // 🔥 ADD THIS

        if (selectedStore && selectedRequisition) {
            setLoading(true);

            RequestServies.getAllItem(
                selectedRequisition,
                "all",
                selectedStore
            )
                .then((res) => {
                    // 🔥 ONLY UPDATE IF STILL VALID
                    if (isActive && selectedRequisition) {
                        setData(res?.data?.data || []);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    console.error(error);
                });
        } else {
            setData([]);
        }

        // 🔥 CLEANUP (VERY IMPORTANT)
        return () => {
            isActive = false;
        };
    }, [selectedStore, selectedRequisition, run]);

    const handleStoreChange = (e) => {
        setSelectedStore(e.target.value);
    };

    const handleRequsitionChange = (e) => {
        setSelectedRequisiton(e.target.value);
    };

    useEffect(() => {
        if (data.length > 0) {
            setTest(0);
            activePag.current = 0;
        }
    }, [data]);





    const handleShowInventory = (e, item) => {
        setSelectedItem2(item);
        setGridInsideModal2(true);
    };

    const handleQtyClick = (item) => {
        setEditItemId(item?._id);
        setEditQty(item?.approveQty);
    };

    const handleQtyUpdate = async (item) => {
    try {
        await RequestServies.updateApproveQtyByDirector(item._id, {
            approveQty: editQty, // ✅ new API key
        });

        Swal.fire({
            icon: "success",
            title: "Updated!",
            text: "Approve Quantity updated successfully!",
            timer: 1500,
            showConfirmButton: false,
        });

        setEditItemId(null);
        setRun((prev) => prev + 1); // 🔁 refresh

    } catch (error) {
        console.error(error);
        Swal.fire({
            icon: "error",
            title: "Error",
            text: error?.response?.data?.message || "Failed to update quantity",
        });
    }
};

    const handleKeyDown = (e, item) => {
        if (e.key === "Enter") {
            handleQtyUpdate(item);
        }
    };

    useEffect(() => {
        if (!selectedRequisition) {
            setData([]);
        }
    }, [selectedRequisition]);


    // ✅ Single select
    const handleSelect = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id)
                ? prev.filter((item) => item !== id)
                : [...prev, id]
        );
    };

    // ✅ Select all
    const handleSelectAll = () => {
        if (selectedIds.length === data.length) {
            setSelectedIds([]);
        } else {
            setSelectedIds(data.map((item) => item._id));
        }
    };

    useEffect(() => {
        if (data.length > 0) {
            setSelectedIds(prev =>
                prev.length > 0
                    ? data
                        .map(item => item._id)
                        .filter(id => prev.includes(id)) // ✅ preserve selection
                    : data.map(item => item._id) // first load only
            );
        } else {
            setSelectedIds([]);
        }
    }, [data]);

    const handleBulkApprove = async () => {
        if (selectedIds.length === 0) {
            return Swal.fire("Warning", "Please select at least one item", "warning");
        }

        try {
            const payload = {
                items: data
                    .filter(item => selectedIds.includes(item._id))
                    .map(item => ({
                        id: item._id,
                        status: item.status
                    }))
            };

            await RequestServies.bulkApproveByDirector(payload);

            Swal.fire("Success", "Bulk approval done", "success");

            setSelectedIds([]);
            setRun(prev => prev + 1);

        } catch (error) {
            Swal.fire("Error", error?.message || "Something went wrong", "error");
        }
    };

    const handleModeClick = (item) => {
        setEditModeId(item._id);
        setEditModeValue(item.status);
    };
    const handleModeUpdate = async (item, value) => {
        try {
            await RequestServies.updateStatusByDirector(item._id, {
                status: value, // ✅ DIRECT VALUE
            });

            Swal.fire({
                icon: "success",
                title: "Updated!",
                text: "Mode updated successfully!",
                timer: 1200,
                showConfirmButton: false,
            });

            setEditModeId(null);
            setRun(prev => prev + 1);

        } catch (error) {
            Swal.fire("Error", "Failed to update mode", "error");
        }
    };

    const handleModeChange = (e, item) => {
        const value = e.target.value;

        setEditModeValue(value); // optional (for UI)

        handleModeUpdate(item, value); // ✅ PASS VALUE
    };

    const handleReturn = async () => {

        // ✅ check requisition selected
        if (!selectedRequisition) {
            return Swal.fire("Warning", "No requisition selected", "warning");
        }

        // ✅ store current selection (IMPORTANT)
        const prevSelected = [...selectedIds];

        // ✅ ask for remark
        const { value: remark } = await Swal.fire({
            title: "Return to Admin",
            input: "textarea",
            inputLabel: "Enter Reason (Mandatory)",
            inputPlaceholder: "Enter return reason...",
            showCancelButton: true,
            inputValidator: (value) => {
                if (!value) return "Remark is required!";
            }
        });

        if (!remark) return;

        try {
            // ✅ API call
            await RequestServies.returnToAdminByDirector({
                requisitionId: selectedRequisition,
                remark
            });

            Swal.fire("Success", "Returned to Admin successfully", "success");

            // 🔁 refresh
            setRun(prev => prev + 1);

            // ✅ restore selection after refresh
            setTimeout(() => {
                setSelectedIds(prevSelected);
            }, 300);

        } catch (error) {
            Swal.fire("Error", error?.message || "Something went wrong", "error");
        }
    };
    return (
        <>
            {gridInsideModal2 && selectedItem2 && (
                <ItemsModal
                    show={gridInsideModal2}
                    item={selectedItem2}
                    handleClose={() => setGridInsideModal2(false)}
                />
            )}

            <div className="row">
                {loading ? (
                    <div className="text-center my-4">
                        <Spinner animation="border" />
                        <div>Loading Data...</div>
                    </div>
                ) : (
                    <div className="col-xl-12">
                        {/* FILTER */}
                        <div className="filter cm-content-box box-primary">
                            <div className="content-title">
                                <div className="cpa">Filter</div>
                                <div className="tools">
                                    <Link to="#" onClick={() => setOpen(!open)}>
                                        <i className="fas fa-angle-up"></i>
                                    </Link>
                                </div>
                            </div>

                            <Collapse in={open}>
                                <div className="cm-content-body form excerpt">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-xl-6">
                                                <label>Select Store</label>
                                                <select
                                                    className="form-select"
                                                    value={selectedStore || ""}
                                                    onChange={handleStoreChange}
                                                >
                                                    {stores.length > 0 ? (
                                                        stores.map((store) => (
                                                            <option key={store.storeId} value={store.storeId}>
                                                                {store.storeName}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="">No Store Available</option>
                                                    )}
                                                </select>
                                            </div>

                                            <div className="col-xl-6">
                                                <label>Select Requisition</label>
                                                <label>Select Requisition</label>
                                                <select
                                                    className="form-select"
                                                    value={selectedRequisition || ""}
                                                    onChange={handleRequsitionChange}
                                                >
                                                    {requisition && requisition.length > 0 ? (
                                                        requisition.map((item) => (
                                                            <option key={item._id} value={item._id}>
                                                                {item.requisitionNo}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="">No Requisition Available</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>

                        {/* TABLE */}
                        <div className="filter cm-content-box box-primary mt-1">
                            <div className="content-title d-flex justify-content-between align-items-center">

                                {/* LEFT: Title + Count */}
                                <div className="cpa">
                                    SuperBoss Approval
                                    <span className="badge bg-orange ms-2">{data.length}</span>
                                </div>

                                {/* CENTER: RETURN BUTTON */}
                                <div>
                                    <button
                                        className="btn btn-warning btn-sm"
                                        onClick={handleReturn}
                                        disabled={!selectedRequisition}
                                    >
                                        Return Back to Central Team
                                    </button>
                                </div>

                                {/* RIGHT: BULK BUTTON */}
                                <div>
                                    <button
                                        className="btn btn-success btn-sm"
                                        onClick={handleBulkApprove}
                                        disabled={selectedIds.length === 0}
                                    >
                                        Bulk Approve ({selectedIds.length})
                                    </button>
                                </div>

                            </div>

                            <Collapse in={open2}>
                                <div className="cm-content-body form excerpt">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <div style={{
                                                overflowX: 'auto',
                                                overflowY: 'auto',
                                                maxHeight: '400px',
                                                whiteSpace: 'nowrap'
                                            }}>
                                                <table className="table table-bordered table-striped">
                                                    <thead
                                                        style={{
                                                            position: "sticky",
                                                            top: 0,
                                                            backgroundColor: "#fff", // White background
                                                            zIndex: 2,
                                                        }}
                                                    >

                                                        <tr>
                                                            <th>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedIds.length === data.length && data.length > 0}
                                                                    onChange={handleSelectAll}
                                                                />
                                                            </th>
                                                            <th>S.No</th>
                                                            <th>Req No</th>
                                                            <th>Store</th>
                                                            <th>Type</th>
                                                            <th>Part No</th>
                                                            <th>Description</th>
                                                            <th>Auth Qty</th>
                                                            <th>Current Qty</th>
                                                            <th>Req Qty</th>
                                                            <th>App. Qty</th>
                                                            <th>Mode</th>
                                                            <th>Action By</th>
                                                            <th>Remark</th>
                                                            <th>Indigo Stock</th>


                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {data.length > 0 ? (
                                                            data.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedIds.includes(item._id)}
                                                                            onChange={() => handleSelect(item._id)}
                                                                        />
                                                                    </td>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item?.requisitionNo?.requisitionNo}</td>
                                                                    <td>{item?.requisitionNo?.store?.name}</td>
                                                                    <td>{item?.requisitionNo?.revisionType}</td>

                                                                    <td>{item?.inventory?.masterItem?.partNo}</td>
                                                                    <td className="scrollable-description">{item?.inventory?.masterItem?.description}</td>
                                                                    <td>{item?.inventory?.qtyAuth}</td>
                                                                    <td>{item?.inventory?.currentStock}</td>
                                                                    <td>{item?.qtyRequired}</td>
                                                                    <td onClick={() => handleQtyClick(item)} style={{ cursor: "pointer" }}>
                                                                        {editItemId === item._id ? (
                                                                            <input
                                                                                type="number"
                                                                                value={editQty}
                                                                                autoFocus
                                                                                onChange={(e) => setEditQty(e.target.value)}
                                                                                onKeyDown={(e) => handleKeyDown(e, item)}
                                                                                onBlur={() => setEditItemId(null)} // optional
                                                                                className="form-control form-control-sm"
                                                                                style={{ width: "80px" }}
                                                                            />
                                                                        ) : (
                                                                            item?.approveQty
                                                                        )}
                                                                    </td>
                                                                    <td className="scrollable-description"
                                                                        onClick={() => handleModeClick(item)}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        {editModeId === item._id ? (
                                                                            <select
                                                                                className="form-select form-select-sm"
                                                                                value={editModeValue}
                                                                                autoFocus
                                                                                onChange={(e) => handleModeChange(e, item)}
                                                                                onBlur={() => setEditModeId(null)}
                                                                            >
                                                                                <option value="approvedBySuperAdmin">PO</option>
                                                                                <option value="local">Local</option>
                                                                                <option value="tranfer request">Transfer</option>
                                                                                <option value="rejected">Rejected</option>
                                                                            </select>
                                                                        ) : (
                                                                            <>
                                                                                {item?.status === "approvedBySuperAdmin"
                                                                                    ? "PO"
                                                                                    : item.status}

                                                                                {/* ✅ NEW LINE REMARK */}
                                                                                {item?.adminRemark && (
                                                                                    <>
                                                                                        <br />
                                                                                        <small style={{ color: "red" }}>
                                                                                            {item?.adminRemark}
                                                                                        </small>
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </td>

                                                                    {/* ✅ ACTION BY */}
                                                                    <td>
                                                                        {item?.approvedBySuperAdmin?.name || "-"}
                                                                    </td>
                                                                    {index === 0 && (
                                                                        <td
                                                                            rowSpan={data.length}
                                                                            style={{
                                                                                verticalAlign: "middle",
                                                                                textAlign: "center",
                                                                                fontWeight: "500",
                                                                                whiteSpace: "pre-wrap"
                                                                            }}
                                                                        >
                                                                            {item?.requisitionNo?.directorRemark && (
                                                                                <div style={{ color: "red", marginBottom: '10px' }}>
                                                                                    D: {item?.requisitionNo?.directorRemark}
                                                                                </div>
                                                                            )}

                                                                            {item?.requisitionNo?.superAdminRemark && (
                                                                                <div style={{ color: "blue" }}>
                                                                                    SA: {item?.requisitionNo?.superAdminRemark}
                                                                                </div>
                                                                            )}

                                                                            {!item?.requisitionNo?.directorRemark &&
                                                                                !item?.requisitionNo?.superAdminRemark && "-"}
                                                                        </td>
                                                                    )}
                                                                    <td>
                                                                        <button
                                                                            className="btn btn-dark btn-xs sharp"
                                                                            onClick={(e) =>
                                                                                handleShowInventory(e, item)
                                                                            }
                                                                        >
                                                                            <i className="fas fa-search"></i>
                                                                        </button>
                                                                    </td>








                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="15" className="text-center">
                                                                    No Data Found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* PAGINATION SAME STYLE */}
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default SuperBossPendingApproval;